export const REGIONS = [
  {
    label: 'Москва и МО',
    value: 'Москва и МО',
  },
  {
    label: 'Санкт-Петербург и ЛО',
    value: 'Санкт-Петербург и ЛО',
  },
];

export const MOSCOW_REGIONS = ['Москва', 'Московская область'];

export const SAINTP_REGIONS = ['Санкт-Петербург', 'Ленинградская область'];

export const ACCEPTED_REGIONS_VALUE = [...MOSCOW_REGIONS, ...SAINTP_REGIONS];
